import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#2979FF",
    },
    secondary: {
      main: "#00B8D4",
    },
    background: {
      default: "#0c121f",
      paper: "#1e1e2f",
    },
    text: {
      primary: "#E0E0E0",
      secondary: "#D3D3D3",
    },
    divider: "#424242",
    success: { main: "#4CAF50" },
    error: { main: "#D32F2F" },
    warning: { main: "#FFEB3B" },
  },
  typography: {
    fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: "none",
        },
      },
    },
  },
});

export default theme;
